<osp-tab-view [(activeIndex)]="activeIndex">
  @for (day of days; track day) {
    <ng-template
      ospTab
      [showActive]="formChange() | hoursInDaySelected: day"
      [header]="(dayLabels() ?? {})[day] ?? day"
    >
    </ng-template>
  }
</osp-tab-view>
<div [formGroup]="form">
  <osp-timefence-day [formControl]="formControl()"></osp-timefence-day>
</div>
